import IFindCaminhaoRequest from '../entities/FindCaminhaoRequest'
import IFindCaminhaoResponse from '../entities/FindCaminhaoResponse'
import { ICaminhaoRepository } from '../repositories/ICaminhaoRepository'

export interface IFindCaminhaoByDescricao {
  execute(params: IFindCaminhaoRequest): Promise<IFindCaminhaoResponse>
}

export default class FindCaminhaoByDescricaoImpl
  implements IFindCaminhaoByDescricao
{
  constructor(private readonly caminhaoRepository: ICaminhaoRepository) {}

  public async execute(
    params: IFindCaminhaoRequest,
  ): Promise<IFindCaminhaoResponse> {
    const response = await this.caminhaoRepository.findByDescricao(params)
    return response
  }
}
